import React, { ForwardedRef, forwardRef, useEffect } from "react";
import clxs from "./In-villa-services.module.css";
import Carousel from "../../Carousel";
import Scroller from "../../Scroller";
import useClx from "../../../hooks/use-clx";
import Item from "../../Carousel/Item";
import inVillaArrowIcon from "../../../assets/icons/in-villa-arrow.svg";
import { useCarouselScroller } from "../../../hooks/use-carousel";
import Modal, { useShowModal } from "../../../hooks/use-modal";
import ServiceDetails from "./ServiceDetails";

interface InVillaServicesProps {
  carouselId: string;
  activeInvillaServices: services[];
  title: string;
  subtitle?: string;
  className?: string;
}

const InVillaServices = forwardRef(
    function AmenitiesCore(
      props: InVillaServicesProps,
      ref: ForwardedRef<HTMLDivElement>,
    ) {
  const { carouselId, title, subtitle, className, activeInvillaServices } =
      props,
    scx = useClx(clxs.section, className),
    { scrollLeft, scrollRight, leftCount, rightCount } =
      useCarouselScroller(carouselId),
      showServiceDetailsModal = useShowModal(DETAILS_MODAL_ID),
      handleShowServiceDetail = (activeInvillaServices : services) => {showServiceDetailsModal({ activeInvillaServices: activeInvillaServices ?? [] })};

       // 👇text truncation effect
  useEffect(() => {
    const truncateText = (selector: string, lines: number, lineHeight: number) => {
      const maxHeight = lines * lineHeight;
      const elements = document.querySelectorAll(selector);
    
      elements.forEach((el) => {
        const originalText = el.getAttribute("data-original") || el.textContent || "";
        const words = originalText.split(" ");
        let truncated = "";
    
        el.setAttribute("data-original", originalText); 
    
        for (let i = 0; i < words.length; i++) {
          const testText = words.slice(0, i + 1).join(" ") + "…";
          el.textContent = testText;
    
          if (el.scrollHeight > maxHeight) {
            el.textContent = words.slice(0, i).join(" ") + "…";
            return;
          }
    
          truncated = testText;
        }
    
        el.textContent = truncated; // full text fits without needing "…"
      });
    };
    

    truncateText(".services-description", 2, 16); // 2 lines, 16px line-height
  }, [activeInvillaServices]);


  return (
    <>
    <div 
      className={scx}
      ref={ref}
    >
      <div className={clxs.title}>{title}</div>
      {subtitle && <div className={clxs.subtitle}>{subtitle}</div>}
      <Carousel
        id={carouselId}
        className={clxs.carousel}
        threshold={0.9}
        adjust={true}
      >
        {activeInvillaServices.map((each, i) => {
          const { image, name, description } = each;

          return (
            <Item 
              key={i} 
              className={clxs.item}
            >
              <div className={clxs.activeInvillaServicesContainer}>
                <div className={clxs.servicesImageContainer}>
                  <img
                    loading="lazy"
                    src={image}
                    alt="Lohono"
                    className={clxs.servicesImage}
                  />
                </div>
                <div 
                  className={clxs.contentContainer}
                  onClick={()=>handleShowServiceDetail(each)}
                >
                  <div className={clxs.servicesName}>{name}</div>
                  <img
                    loading="lazy"
                    src={inVillaArrowIcon}
                    alt="Lohono"
                    className={clxs.inVillaArrowIcon}
                  />
                  <div className={`${clxs.servicesDescription} services-description`}>{description}</div>
                </div>
              </div>
            </Item>
          );
        })}
      </Carousel>
      {activeInvillaServices.length > 3 && (
        <Scroller
          className={clxs.scroller}
          onScrollLeft={scrollLeft}
          onScrollRight={scrollRight}
          isLeftDisabled={leftCount === 0}
          isRightDisabled={rightCount === 0}
          isSmallIcon={true}
        />
      )}
    </div>
    <Modal id={DETAILS_MODAL_ID}>
      <ServiceDetails/>
    </Modal>
    </>
  );
})

export default InVillaServices;

const DETAILS_MODAL_ID = "in-villa-services-details";
